var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTickPink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    rx: 8,
    fill: "#FB37A3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2507 27.1673H20.7507C25.334 27.1673 27.1673 25.334 27.1673 20.7507V15.2507C27.1673 10.6673 25.334 8.83398 20.7507 8.83398H15.2507C10.6673 8.83398 8.83398 10.6673 8.83398 15.2507V20.7507C8.83398 25.334 10.6673 27.1673 15.2507 27.1673Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1035 18.0004L16.6977 20.5946L21.8952 15.4062",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickPink);
export default __webpack_public_path__ + "static/media/tick-pink.54391a804dd164aac7bbca56608b6790.svg";
export { ForwardRef as ReactComponent };